import Cover from '../../components/Cover';
import './style.scss';
import FlipSide from '../../components/FlipSide';
import ContentCircles from '../../components/ContentCircles';

function Home () {
    return (
        <div className='home-screen'>
            <Cover/>
            <FlipSide 
                className={'first-flipSide-component'}
                title={'EGÉSZSÉG'}
                imageUrl={'/img/egeszseg.jpg'} 
                description={'Minden szolgáltatásunkat úgy alakítottuk ki, hogy segítsünk Önnek megőrizni és javítani életminőségét. Modern környezetben, szakértő kezek között biztos lehet abban, hogy minden szükséges támogatást megkap a legjobb eredmények érdekében. Vegye igénybe szolgáltatásaink egyikét és tegyen egy lépést az egészségesebb jövőért velünk!'}
                backgroundColor={'white'}
                color={'#212429'}
            /> 
            <FlipSide 
                className={'second-flipSide-component'}
                title={'PREVENCIÓ'} 
                imageUrl={'/img/szakertelem.jpg'} 
                description={'A Váci Belvárosi Egészségközpont elkötelezett az egészségmegőrzés iránt, ezért olyan innovatív megoldásokat kínál, amelyek az egészség megőrzését állítják középpontba. A szakmai tapasztalat és korszerű technológia ötvözetével célunk, hogy pácienseink számára komplex és személyre szabott ellátást biztosítsunk, amely elősegíti a hosszú távú jólétet. Az Ön egészsége a mi küldetésünk.'}
                backgroundColor={'white'}
                color={'#212429'}
                reverse={true}
            />
            <FlipSide 
                className={'third-flipSide-component'}
                title={'SZAKÉRTELEM'} 
                imageUrl={'/img/precizitas.jpg'} 
                description={'Váci belvárosi egészségközpontunkban szakértő csapatunk a legjobb gondoskodást nyújtja Önnek. Tapasztalt orvosaink és szakembereink minden esetet alaposan megvizsgálnak, hogy biztosítani tudják a legmegfelelőbb kezelést és támogatást.'}
                backgroundColor={'white'}
                color={'#212429'}
            /> 
            <ContentCircles/>
        </div>
    );
};

export default Home;